// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"294":"0c541259","787":"36ade64c","815":"2370ab5e"}[chunkId] + ".chunk.js";
};